import request from '@/util/request';
import qs from 'qs';


export const getNursinghomeList = (params, options) =>
  request.get(
    '/api/nursing/getNursinghome',
    Object.assign({}, options, { params })
  );